export const {
    VERSION,
    BACKEND_HOST,
    BACKEND_SCHEME,
    SENTRY_DSN,
    SENTRY_ENV,
    SENTRY_RELEASE,
} = process.env;

export const ROOT_URL = `${BACKEND_SCHEME}://${BACKEND_HOST}/api/v1/`;
export const ROOT_URL_V2 = `${BACKEND_SCHEME}://${BACKEND_HOST}/api/v2/`;
export const SERVER_URL = `${BACKEND_SCHEME}://${BACKEND_HOST}`;
export const FRONTEND_SERVER = `${process.env.FRONTEND_SCHEME}://${process.env.FRONTEND_HOST}`;
export const BUZZHIRE_AGENCY_PK = 1;
export const LANDING_PAGE_URL = 'https://www.berryrecruitment.co.uk';

export function getCSRFToken() {
    const name = 'csrftoken';
    function escape(s) {
        // eslint-disable-next-line no-useless-escape
        return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1');
    }
    const match = document.cookie.match(
        RegExp(`(?:^|;\\s*)${escape(name)}=([^;]*)`),
    );
    return match ? match[1] : null;
}
